/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Swal_Single_TextInputs */



/**
* | output |
* | --- |
* | "Would you like to merge the selected event with the event before or after it?" |
*
* @param {Merge_Swal_Single_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_swal_single_text = /** @type {((inputs?: Merge_Swal_Single_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Swal_Single_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Souhaitez-vous fusionner l'evenement selectionne avec l'evenement precedent ou suivant ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Möchten Sie das ausgewählte Ereignis mit dem vorhergehenden oder dem nachfolgenden Ereignis zusammenführen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Desideri unire l'evento selezionato con quello precedente o successivo?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы хотите объединить выбранное событие с событием, предшествующим или следующим за ним?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Quieres fusionar el evento seleccionado con el evento anterior o posterior?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您想将选定的事件与其前一个事件还是后一个事件合并？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントをその前または後のイベントと結合しますか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आप चयनित इवेंट को उससे पहले या बाद वाले इवेंट के साथ मर्ज करना चाहेंगे?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deseja mesclar o evento selecionado com o evento anterior ou posterior?")
	return /** @type {LocalizedString} */ ("Would you like to merge the selected event with the event before or after it?")
});